import axios from "axios";
import { BASE_API_URL } from "../constants/dropdown";

// Action Types
export const GET_REFERRAL_ANALYTICS_REQUEST = "GET_REFERRAL_ANALYTICS_REQUEST";
export const GET_REFERRAL_ANALYTICS_SUCCESS = "GET_REFERRAL_ANALYTICS_SUCCESS";
export const GET_REFERRAL_ANALYTICS_FAIL = "GET_REFERRAL_ANALYTICS_FAIL";

export const GET_REFERRAL_REFERRERS_REQUEST = "GET_REFERRAL_REFERRERS_REQUEST";
export const GET_REFERRAL_REFERRERS_SUCCESS = "GET_REFERRAL_REFERRERS_SUCCESS";
export const GET_REFERRAL_REFERRERS_FAIL = "GET_REFERRAL_REFERRERS_FAIL";

export const GET_REFERRAL_LEADERBOARD_REQUEST =
  "GET_REFERRAL_LEADERBOARD_REQUEST";
export const GET_REFERRAL_LEADERBOARD_SUCCESS =
  "GET_REFERRAL_LEADERBOARD_SUCCESS";
export const GET_REFERRAL_LEADERBOARD_FAIL = "GET_REFERRAL_LEADERBOARD_FAIL";

export const GET_REFERRER_DETAIL_REQUEST = "GET_REFERRER_DETAIL_REQUEST";
export const GET_REFERRER_DETAIL_SUCCESS = "GET_REFERRER_DETAIL_SUCCESS";
export const GET_REFERRER_DETAIL_FAIL = "GET_REFERRER_DETAIL_FAIL";

export const GET_REFERRAL_DETAIL_REQUEST = "GET_REFERRAL_DETAIL_REQUEST";
export const GET_REFERRAL_DETAIL_SUCCESS = "GET_REFERRAL_DETAIL_SUCCESS";
export const GET_REFERRAL_DETAIL_FAIL = "GET_REFERRAL_DETAIL_FAIL";

export const GET_REFERRAL_LINK_REQUEST = "GET_REFERRAL_LINK_REQUEST";
export const GET_REFERRAL_LINK_SUCCESS = "GET_REFERRAL_LINK_SUCCESS";
export const GET_REFERRAL_LINK_FAIL = "GET_REFERRAL_LINK_FAIL";

export const GET_STAFF_LEADERBOARD_REQUEST = "GET_STAFF_LEADERBOARD_REQUEST";
export const GET_STAFF_LEADERBOARD_SUCCESS = "GET_STAFF_LEADERBOARD_SUCCESS";
export const GET_STAFF_LEADERBOARD_FAIL = "GET_STAFF_LEADERBOARD_FAIL";

export const GET_REFERRAL_STATES_REQUEST = "GET_REFERRAL_STATES_REQUEST";
export const GET_REFERRAL_STATES_SUCCESS = "GET_REFERRAL_STATES_SUCCESS";
export const GET_REFERRAL_STATES_FAIL = "GET_REFERRAL_STATES_FAIL";

export const GET_ALL_REFERRALS_REQUEST = "GET_ALL_REFERRALS_REQUEST";
export const GET_ALL_REFERRALS_SUCCESS = "GET_ALL_REFERRALS_SUCCESS";
export const GET_ALL_REFERRALS_FAIL = "GET_ALL_REFERRALS_FAIL";

export const GET_REFERRAL_TYPES_REQUEST = "GET_REFERRAL_TYPES_REQUEST";
export const GET_REFERRAL_TYPES_SUCCESS = "GET_REFERRAL_TYPES_SUCCESS";
export const GET_REFERRAL_TYPES_FAIL = "GET_REFERRAL_TYPES_FAIL";

export const RETAG_REFERRAL_REQUEST = "RETAG_REFERRAL_REQUEST";
export const RETAG_REFERRAL_SUCCESS = "RETAG_REFERRAL_SUCCESS";
export const RETAG_REFERRAL_FAIL = "RETAG_REFERRAL_FAIL";
export const RETAG_REFERRAL_RESET = "RETAG_REFERRAL_RESET";

// Helper to get auth config
const getConfig = (getState) => {
  const {
    admin2faLogin: { userInfo },
  } = getState();
  const token = userInfo?.token?.access_token;
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

// Helper to build query string from params
const buildQuery = (params) => {
  const valid = Object.entries(params).filter(
    ([_, v]) => v !== "" && v !== null && v !== undefined,
  );
  if (valid.length === 0) return "";
  return "?" + valid.map(([k, v]) => `${k}=${v}`).join("&");
};

// Fetch referral analytics
export const fetchReferralAnalytics =
  (fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_ANALYTICS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/analytics${query}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_ANALYTICS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_ANALYTICS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch referrers list
export const fetchReferrers =
  (page = 1, pageSize = 10, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_REFERRERS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/referrers${query}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_REFERRERS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_REFERRERS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch leaderboard
export const fetchReferralLeaderboard =
  (page = 1, pageSize = 10, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_LEADERBOARD_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard${query}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_LEADERBOARD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_LEADERBOARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch single referrer detail (with their referrals list)
export const fetchReferrerDetail =
  (referrerId, page = 1, pageSize = 10) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRER_DETAIL_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/${referrerId}?page=${page}&pageSize=${pageSize}`,
        config,
      );
      dispatch({ type: GET_REFERRER_DETAIL_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRER_DETAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch single referral detail
export const fetchReferralDetail =
  (referrerId, refereeId) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_DETAIL_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/${referrerId}/${refereeId}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_DETAIL_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_DETAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const fetchReferralLink =
  (referrerTag) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_LINK_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/link?referrerTag=${referrerTag}`,
        config
      )
      dispatch({ type: GET_REFERRAL_LINK_SUCCESS, payload: data })
      return data                                              // ← ADD
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_LINK_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
      throw error                                              // ← ADD
    }
  }

// Fetch staff leaderboard
export const fetchStaffLeaderboard =
  (page = 1, pageSize = 10, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_STAFF_LEADERBOARD_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard/admin${query}`,
        config,
      );
      dispatch({ type: GET_STAFF_LEADERBOARD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_STAFF_LEADERBOARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch all referrals
export const fetchAllReferrals =
  (page = 1, pageSize = 100, fromDate = "", toDate = "", referrerId = "", refereeId = "", referrerTypeId = "", refereeTypeId = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_REFERRALS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate, referrerId, refereeId, referrerTypeId, refereeTypeId });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/all${query}`,
        config,
      );
      dispatch({ type: GET_ALL_REFERRALS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_ALL_REFERRALS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch referral types
export const fetchReferralTypes = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_REFERRAL_TYPES_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/referrals/type`,
      config,
    );
    dispatch({ type: GET_REFERRAL_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_REFERRAL_TYPES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Fetch referral states
export const fetchReferralStates = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_REFERRAL_STATES_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/referrals/state`,
      config,
    );
    dispatch({ type: GET_REFERRAL_STATES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_REFERRAL_STATES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Retag referrals (bulk)
export const retagReferral = (postData) => async (dispatch, getState) => {
  try {
    dispatch({ type: RETAG_REFERRAL_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/retag`,
      postData,
      config,
    );
    dispatch({ type: RETAG_REFERRAL_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RETAG_REFERRAL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ── Milestones ────────────────────────────────────────────────────────────────

export const fetchMilestones =
  (activeOnly = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_MILESTONES_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ activeOnly });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/milestones${query}`,
        config,
      );
      dispatch({ type: "GET_MILESTONES_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_MILESTONES_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const fetchMilestone = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: "GET_MILESTONE_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/referrals/milestones/${id}`,
      config,
    );
    dispatch({ type: "GET_MILESTONE_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "GET_MILESTONE_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createMilestone = (body) => async (dispatch, getState) => {
  try {
    dispatch({ type: "CREATE_MILESTONE_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/milestones`,
      body,
      config,
    );
    dispatch({ type: "CREATE_MILESTONE_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "CREATE_MILESTONE_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateMilestone = (id, body) => async (dispatch, getState) => {
  try {
    dispatch({ type: "UPDATE_MILESTONE_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.put(
      `${BASE_API_URL}/admin/referrals/milestones/${id}`,
      body,
      config,
    );
    dispatch({ type: "UPDATE_MILESTONE_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "UPDATE_MILESTONE_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ── Cycles ────────────────────────────────────────────────────────────────────

export const fetchReferralCycles =
  (page = 1, pageSize = 10, referrerId = "", statusId = "", fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_REFERRAL_CYCLES_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, referrerId, statusId, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/cycles${query}`,
        config,
      );
      dispatch({ type: "GET_REFERRAL_CYCLES_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_REFERRAL_CYCLES_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ── Reward Withdrawals ────────────────────────────────────────────────────────

export const fetchRewardWithdrawals =
  (page = 1, pageSize = 10, referrerId = "", statusId = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_REWARD_WITHDRAWALS_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, referrerId, statusId });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/reward-withdrawals${query}`,
        config,
      );
      dispatch({ type: "GET_REWARD_WITHDRAWALS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_REWARD_WITHDRAWALS_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ── Milestone Logs ────────────────────────────────────────────────────────────

export const fetchMilestoneLogs =
  (page = 1, pageSize = 10, referrerId = "", statusId = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_MILESTONE_LOGS_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, referrerId, statusId });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/milestone-logs${query}`,
        config,
      );
      dispatch({ type: "GET_MILESTONE_LOGS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_MILESTONE_LOGS_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const acceptMilestoneLog = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: "ACCEPT_MILESTONE_LOG_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/milestone-logs/${id}/accept`,
      {},
      config,
    );
    dispatch({ type: "ACCEPT_MILESTONE_LOG_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "ACCEPT_MILESTONE_LOG_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const rejectMilestoneLog = (id, reason = "") => async (dispatch, getState) => {
  try {
    dispatch({ type: "REJECT_MILESTONE_LOG_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/milestone-logs/${id}/reject`,
      { reason },
      config,
    );
    dispatch({ type: "REJECT_MILESTONE_LOG_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "REJECT_MILESTONE_LOG_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ── Payout Tiers ──────────────────────────────────────────────────────────────

export const fetchPayoutTiers =
  (activeOnly = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_PAYOUT_TIERS_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ activeOnly });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard-payout-tiers${query}`,
        config,
      );
      dispatch({ type: "GET_PAYOUT_TIERS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_PAYOUT_TIERS_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const createPayoutTier = (body) => async (dispatch, getState) => {
  try {
    dispatch({ type: "CREATE_PAYOUT_TIER_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/leaderboard-payout-tiers`,
      body,
      config,
    );
    dispatch({ type: "CREATE_PAYOUT_TIER_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "CREATE_PAYOUT_TIER_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updatePayoutTier = (id, body) => async (dispatch, getState) => {
  try {
    dispatch({ type: "UPDATE_PAYOUT_TIER_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.put(
      `${BASE_API_URL}/admin/referrals/leaderboard-payout-tiers/${id}`,
      body,
      config,
    );
    dispatch({ type: "UPDATE_PAYOUT_TIER_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "UPDATE_PAYOUT_TIER_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ── Leaderboard Winners ───────────────────────────────────────────────────────

export const fetchLeaderboardWinners =
  (page = 1, pageSize = 10, referrerId = "", statusId = "", isPaid = "", periodStart = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_LEADERBOARD_WINNERS_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, referrerId, statusId, isPaid, periodStart });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard-winners${query}`,
        config,
      );
      dispatch({ type: "GET_LEADERBOARD_WINNERS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_LEADERBOARD_WINNERS_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const runLeaderboardPayoutJob =
  (periodStart = null) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "RUN_LEADERBOARD_PAYOUT_REQUEST" });
      const config = getConfig(getState);
      const { data } = await axios.post(
        `${BASE_API_URL}/admin/referrals/leaderboard-winners/run`,
        { period_start: periodStart },
        config,
      );
      dispatch({ type: "RUN_LEADERBOARD_PAYOUT_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "RUN_LEADERBOARD_PAYOUT_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const acceptLeaderboardWinner = (id, body) => async (dispatch, getState) => {
  try {
    dispatch({ type: "ACCEPT_LEADERBOARD_WINNER_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/leaderboard-winners/${id}/accept`,
      body,
      config,
    );
    dispatch({ type: "ACCEPT_LEADERBOARD_WINNER_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "ACCEPT_LEADERBOARD_WINNER_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const rejectLeaderboardWinner = (id, reason = "") => async (dispatch, getState) => {
  try {
    dispatch({ type: "REJECT_LEADERBOARD_WINNER_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/leaderboard-winners/${id}/reject`,
      { reason },
      config,
    );
    dispatch({ type: "REJECT_LEADERBOARD_WINNER_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "REJECT_LEADERBOARD_WINNER_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const markWinnerPaid = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: "MARK_WINNER_PAID_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/referrals/leaderboard-winners/${id}/mark-paid`,
      {},
      config,
    );
    dispatch({ type: "MARK_WINNER_PAID_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "MARK_WINNER_PAID_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
